import { backofficeRolesWithoutAcExpo } from "@ac-expo/api-types";
import { z } from "zod";

export const roleSelectionSchema = z.object({
  roles: z
    .array(z.enum(backofficeRolesWithoutAcExpo))
    .min(1, "Veuillez choisir au moins un profil")
    .max(4),
});

export const defaultRoleSelectionValues = {
  roles: [],
};

export type RoleSelectionForm = z.infer<typeof roleSelectionSchema>;
